// extracted by mini-css-extract-plugin
module.exports = {"theme":"Theme_theme__1C95R","wide":"Theme_wide__T3eSd","input":"Theme_input__xn6El","inner":"Theme_inner__3-eC2","box":"Theme_box__1ng_l"};